import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Actions from 'flow/actions';
import { ActiveCallDirections, convertNumberToE164, toNationalNumberFormat } from 'flow/utils/call-utils';
import { fetchFeatureFlagsForUser } from 'flow/actions/app-actions';
import { showCallDialog } from 'flow/actions/call-dialog-actions';
import { getActionFromIncomingEvent, OUTGOING_EVENTS, INCOMING_EVENTS, INCOMING_POSTMESSAGE_API_FORMAT, OUTGOING_POSTMESSAGE_API_FORMAT } from 'flow/types/integration-event-types';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import HomeClient from 'flow/api-clients/home-client';
import { isEmptyNullOrUndefined, tryParseJsonObject } from 'flow/utils';
import { getFocusedActiveCall, getFocusedSession, getLocalCallIds, getOwnActiveCalls } from 'flow/selectors/call-selectors';
import { hasCtiSettings, getCtiSetting } from 'flow/utils/cti-settings-utils';
import { getIntegrationContactMetaDataByNumber, allowCtiCommunication } from 'flow/selectors/cti-integration-selectors';
import { selectProfileRecordCalls } from 'flow/selectors/profile-selectors';
import { fetchCallRecord } from 'flow/utils/cti-call-log-utils';
import { getBrand } from 'flow/brands/brands';
import { isMainRegistration, setMainRegistration } from 'flow/utils/instance-count-utils';
import { getOwnCountryCode, getOwnExtensionKey } from 'flow/selectors/selectors';
import { selectQueueDescription } from 'flow/selectors/queue-selectors';
import { ctiTraceLog } from 'flow/utils/cti-call-log-utils';
import appConfig from 'app-config';
var INIT_RETRIES = 100;
export var CTI_INTEGRATION_CLIENT_TYPE_HEADER = 'cti-integration';
var send = function send(type, data) {
  return function (_dispatch, getState) {
    var _getState = getState(),
      integration = _getState.integration;
    if (!allowCtiCommunication(getState())) {
      addCtiLogEntry("Won't send ".concat(type, " message since user doesn't have CTI integration feature."));
      return;
    }
    var targetOrigin = integration.get('targetOrigin');
    var message = _objectSpread({
      type: type
    }, data);
    addCtiLogEntry('Send message to host system', message, targetOrigin);
    if (targetOrigin) {
      parent.postMessage(message, targetOrigin);
    } else {
      addCtiLogEntry("Won't send ".concat(type, " message since no target origin was found."));
    }
  };
};
var clearCallLogSent = function clearCallLogSent() {
  return {
    type: Actions.CTI_CLEAR_CALL_LOG_SENT
  };
};
var setCallLogSent = function setCallLogSent() {
  return {
    type: Actions.CTI_CALL_LOG_SENT
  };
};
export var sendInitializedNotification = function sendInitializedNotification(loggedIn) {
  return function (_dispatch, getState) {
    var message = {
      init: 'ialized',
      loggedIn: loggedIn
    };
    if (isEmptyNullOrUndefined(loggedIn)) {
      throw new Error('Invalid loggedIn status.');
    }
    var resendCounter = 0;
    var _sendInitializedNotificationUntilHostRegisters = function sendInitializedNotificationUntilHostRegisters() {
      var _getState2 = getState(),
        integration = _getState2.integration;
      var targetOrigin = integration.get('targetOrigin');
      if (resendCounter > INIT_RETRIES) {
        addCtiLogEntry("No origin registration after ".concat(resendCounter, " tries. Stoping."));
        return;
      }
      if (!targetOrigin) {
        addCtiLogEntry("Sending an init message to host system. Expecting origin registration. Sent message ".concat(++resendCounter, " time(s)"));
        if (hasCtiSettings(getState())) {
          message.ctiSettings = getCtiSetting(getState());
        }
        parent.postMessage(message, '*');
        setTimeout(_sendInitializedNotificationUntilHostRegisters, resendCounter * 250);
      }
    };
    _sendInitializedNotificationUntilHostRegisters();
  };
};
export var userLoggedIn = function userLoggedIn() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      customer = _getState3.customer;
    var extensionKey = getOwnExtensionKey(getState());
    var customerKey = customer.getIn([extensionKey, 'key']);
    var message = {
      extensionKey: extensionKey,
      customerKey: customerKey
    };
    dispatch(send(OUTGOING_EVENTS.USER_LOGGED_IN, message));
    dispatch({
      type: Actions.CTI_USER_LOGGED_IN
    });
  };
};
export var userLoggedOut = function userLoggedOut() {
  return function (dispatch) {
    dispatch(send(OUTGOING_EVENTS.USER_LOGGED_OUT));
    dispatch({
      type: Actions.CTI_USER_LOGGED_OUT
    });
  };
};
export var tooManyInstances = function tooManyInstances(_tooManyInstances) {
  return {
    type: Actions.CTI_SET_TOO_MANY_INSTANCES,
    data: {
      tooManyInstances: _tooManyInstances
    }
  };
};
var getFormattedDirection = function getFormattedDirection(call) {
  return call.direction === ActiveCallDirections.INCOMING.value ? INCOMING_POSTMESSAGE_API_FORMAT : OUTGOING_POSTMESSAGE_API_FORMAT;
};
var getMyNumber = function getMyNumber(call) {
  return call.direction === ActiveCallDirections.INCOMING.value ? call.destination : call.source;
};
var getOtherNumber = function getOtherNumber(call) {
  return call.direction === ActiveCallDirections.INCOMING.value ? call.source : call.destination;
};
export var sendCallLog = function sendCallLog(callInfo, focusedActiveCall) {
  return function (dispatch, getState) {
    addCtiLogEntry('Call info used for call log', callInfo);
    if (focusedActiveCall) {
      addCtiLogEntry('Focused active call', focusedActiveCall.toJS());
    } else {
      addCtiLogEntry('Focused active call was undefined');
    }
    var unansweredQueue = focusedActiveCall.get('state') === 'ringing' && focusedActiveCall.get('queue');
    if (unansweredQueue) {
      // We only log calls that are picked up by an agent in the queue. IE when State is up and Queue is not undefined.
      // This is to avoid logging many call logs when the queue rotates through- or calls all members of the queue.
      addCtiLogEntry('Attempted to send call log when call was picked up outside queue.');
      return;
    }
    if (!callInfo) {
      addCtiLogEntry('Attempted to send call log when no active call was present. This should not happen!');
      return;
    }
    var metadata = getIntegrationContactMetaDataByNumber(getState(), callInfo.remoteNumber);
    var ctiSettings = getCtiSetting(getState());
    var data = _objectSpread(_objectSpread({}, ctiSettings && ctiSettings.logCallsAutomatically && {
      ctiSettings: ctiSettings
    }), {}, {
      myNumber: callInfo.localNumber,
      call: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, callInfo.durationMilliSeconds && {
        durationMilliSeconds: callInfo.durationMilliSeconds
      }), callInfo.durationSeconds && {
        durationSeconds: callInfo.durationSeconds
      }), callInfo.recordingUrl && {
        recordingUrl: callInfo.recordingUrl
      }), callInfo.recordingPageUrl && {
        recordingPageUrl: callInfo.recordingPageUrl
      }), callInfo.answered && {
        answered: callInfo.answered
      }), callInfo.disconnected && {
        disconnected: callInfo.disconnected
      }), {}, {
        numberE164: callInfo.remoteNumber,
        number: toNationalNumberFormat(callInfo.remoteNumber),
        direction: callInfo.direction
      })
    }, metadata && {
      metadata: metadata
    });

    // Only send call log if the instance is the one where the call was made/accepted from
    if (isMainRegistration()) {
      dispatch(send(OUTGOING_EVENTS.CALL_LOG, data));
      dispatch(setCallLogSent());
    } else {
      addCtiLogEntry('isMainRegistration is false, the CALL_LOG event will not be sent');
    }
  };
};
var UNKNOWN_CALLER_ID = '<unknown>';
var unlessUnknown = function unlessUnknown(value) {
  return value === UNKNOWN_CALLER_ID ? undefined : value;
};

// The caller of an incoming call is in 'source', except for a queue call,
// where Top can send it in 'originalCallerId' instead. A queue that could not
// identify the caller sends '<unknown>' or nothing at all, and then we have no
// number to report. Both fields can hold a national number, so convert.
//
// The sentinel is filtered per field before falling back: 'originalCallerId'
// is stored raw ('top-actions.js', 'updateActiveCall'), so collapsing first
// would let an unidentified queue caller hide a real number in 'source'.
var getIncomingCallerNumber = function getIncomingCallerNumber(activeCall, state) {
  var fromTop = unlessUnknown(activeCall.get('originalCallerId')) || unlessUnknown(activeCall.get('source'));
  if (!fromTop) {
    return undefined;
  }
  return convertNumberToE164(fromTop, getOwnCountryCode(state));
};

// Only the 'QueueCallInfo' event names the queue a call came from, and not
// every queue sends a name with it. The call still carries the queue it came
// from, so ask the queue itself for its name when the event had none.
var getQueueName = function getQueueName(activeCall, state) {
  var queueName = activeCall.get('queueName');
  if (queueName) {
    return queueName;
  }
  var queueKey = activeCall.get('queue');
  return queueKey ? selectQueueDescription(state, queueKey) : undefined;
};
export var ctiCallInfoFromActiveCall = function ctiCallInfoFromActiveCall(activeCall, state) {
  return {
    queueName: getQueueName(activeCall, state),
    startTime: activeCall.get('startTime'),
    direction: activeCall.get('direction') === ActiveCallDirections.INCOMING.value ? INCOMING_POSTMESSAGE_API_FORMAT : OUTGOING_POSTMESSAGE_API_FORMAT,
    localNumber: activeCall.get('direction') === ActiveCallDirections.INCOMING.value ? activeCall.get('destination') : activeCall.get('source'),
    remoteNumber: activeCall.get('direction') === ActiveCallDirections.INCOMING.value ? getIncomingCallerNumber(activeCall, state) : activeCall.get('destination')
  };
};

// Shared by handleNewCall and redecorateCall, so a lookup made again sends
// the same fields as the first one.
var decorateActiveCall = function decorateActiveCall(activeCall, callInfo) {
  var bagVariables = activeCall.get('bagVariables');
  return getDecoratedCall(callInfo.remoteNumber, callInfo.direction, bagVariables && bagVariables.toJS(), callInfo.queueName, callInfo.startTime);
};

// NewChannel already delivers the variables set before the call reached this
// extension; they come again as SetBagVariable. Tell those repeats apart.
export var isBagVariableChanged = function isBagVariableChanged(state, extensionKey, callKey, variableName, variableValue) {
  var _state$extensions$get;
  var previousValue = (_state$extensions$get = state.extensions.getIn(['activeLineData', extensionKey])) === null || _state$extensions$get === void 0 || (_state$extensions$get = _state$extensions$get.find(function (call) {
    return call.get('key') === callKey;
  })) === null || _state$extensions$get === void 0 ? void 0 : _state$extensions$get.getIn(['bagVariables', variableName]);
  return JSON.stringify(previousValue) !== JSON.stringify(tryParseJsonObject(variableValue));
};

// Bag variables can arrive after the call has started. Look the contact up
// again with the full set, so a lookup made without them (by phone number)
// is replaced without waiting for the next call event.
export var redecorateCall = function redecorateCall(activeCallKey) {
  return function (dispatch, getState) {
    var focusedActiveCall = getFocusedActiveCall(getState());
    if (!focusedActiveCall || focusedActiveCall.get('key') !== activeCallKey) {
      return;
    }
    var callInfo = ctiCallInfoFromActiveCall(focusedActiveCall, getState());
    dispatch(decorateActiveCall(focusedActiveCall, callInfo));
  };
};
export var handleNewCall = function handleNewCall(activeCallKey) {
  return function (dispatch, getState) {
    var focusedActiveCall = getFocusedActiveCall(getState());
    var isActiveCallKeyFocusedActiveCall = focusedActiveCall ? focusedActiveCall.get('key') === activeCallKey : false;
    if (!isActiveCallKeyFocusedActiveCall) {
      // The event was disptached for a call other than the focused active call. We don't care about these.
      return;
    }
    var callInfo = ctiCallInfoFromActiveCall(focusedActiveCall, getState());
    var metadata = getIntegrationContactMetaDataByNumber(getState(), callInfo.remoteNumber);
    dispatch(decorateActiveCall(focusedActiveCall, callInfo));
    switch (callInfo.direction) {
      case INCOMING_POSTMESSAGE_API_FORMAT:
        {
          dispatch(send(OUTGOING_EVENTS.INCOMING_CALL, _objectSpread({
            number: callInfo.remoteNumber,
            numberE164: callInfo.remoteNumber
          }, metadata && {
            metadata: metadata
          })));
          break;
        }
      case OUTGOING_POSTMESSAGE_API_FORMAT:
        {
          dispatch(send(OUTGOING_EVENTS.OUTGOING_CALL_STARTED, _objectSpread({
            number: callInfo.remoteNumber,
            numberE164: callInfo.remoteNumber
          }, metadata && {
            metadata: metadata
          })));
          break;
        }
    }
  };
};
export var callHungup = function callHungup(activeCallKey, locutusSessionId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var focusedActiveCall, numberOfActiveCalls, isActiveCallKeyFocusedActiveCall, callInfo, callRecordDto, disconnected, answered, start, finish, host, brandAppUrl, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            focusedActiveCall = getFocusedActiveCall(getState());
            numberOfActiveCalls = getOwnActiveCalls(getState()).size;
            ctiTraceLog(getState(), "numberOfActiveCalls: ".concat(numberOfActiveCalls), locutusSessionId);
            isActiveCallKeyFocusedActiveCall = focusedActiveCall ? focusedActiveCall.get('key') === activeCallKey : false;
            if (!(!isActiveCallKeyFocusedActiveCall || numberOfActiveCalls > 1)) {
              _context.next = 1;
              break;
            }
            ctiTraceLog(getState(), "The event was dispatched for a call other than the focused active call isActiveCallKeyFocusedActiveCall: ".concat(isActiveCallKeyFocusedActiveCall, " numberOfActiveCalls: ").concat(numberOfActiveCalls), locutusSessionId);
            // The event was dispatched for a call other than the focused active call. We don't care about these.
            // If there is more than one active call left, then this client was denied the call, either from an
            // enduser hangup, or from a nother client picking it up (making this active call hang up). Either way,
            // once the session actually ends, there will be another hangup, so chill.
            return _context.abrupt("return");
          case 1:
            dispatch(send(OUTGOING_EVENTS.CALL_ENDED));

            // If host system is Zendesk and customer has Zendesk Call Logging installed,
            // don't send CALL_LOG to host system.
            // This is to be able to release Zendesk 2.0 without breaking Zendesk 1.0,
            // https://telavox.atlassian.net/browse/INTE-4104.
            if (!(getState().integration.getIn(['integrationConfig', 'hostDescription']) === 'Zendesk' && getState().app.getIn(['extension', 'hasZendeskCallLoggingApp']))) {
              _context.next = 2;
              break;
            }
            addCtiLogEntry('User has installed Zendesk Call Logging, CALL_LOG message will not be sent to host system');
            return _context.abrupt("return");
          case 2:
            callInfo = ctiCallInfoFromActiveCall(focusedActiveCall, getState()); // Locutus ID will not be available everywhere until all SIP servers / TOP servers are upgraded
            // with the following patch: https://github.com/Telavox/proxy/pull/1098. When it's rolled out
            // everywhere we can remove the if-statement below.
            if (!locutusSessionId) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return fetchCallRecord(locutusSessionId)(dispatch);
          case 3:
            callRecordDto = _context.sent;
            disconnected = callRecordDto.disconnected, answered = callRecordDto.answered;
            ctiTraceLog(getState(), "disconnected ".concat(disconnected, " answered ").concat(answered), locutusSessionId);
            if (disconnected && answered) {
              start = new Date(answered).getTime();
              finish = new Date(disconnected).getTime();
              callInfo.durationMilliSeconds = finish - start;
              callInfo.durationSeconds = Math.round(callInfo.durationMilliSeconds / 1000);
              callInfo.answered = start;
              callInfo.disconnected = finish;
            }
            if (selectProfileRecordCalls(getState())) {
              host = HomeClient.apiHost || appConfig.apiUrl;
              callInfo.recordingUrl = "".concat(host, "/api/internal/calls/call-").concat(locutusSessionId, "/recording");
            }
            brandAppUrl = getBrand().brandAppUrl;
            if (brandAppUrl) {
              callInfo.recordingPageUrl = "".concat(getBrand().brandAppUrl, "/callrecording/call-").concat(locutusSessionId);
            }
            ctiTraceLog(getState(), "recordingUrl ".concat(callInfo.recordingUrl, " recordingPageUrl ").concat(callInfo.recordingPageUrl), locutusSessionId);
          case 4:
            dispatch(sendCallLog(callInfo, focusedActiveCall));
            dispatch(clearCallLogSent());
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](0);
            ctiTraceLog(getState(), "callHungup ".concat(JSON.stringify(_t)), locutusSessionId);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var callAnswered = function callAnswered(activeCallKey) {
  return function (dispatch, getState) {
    var _ctiSettings$openOnAn;
    var ownActiveCalls = getOwnActiveCalls(getState());
    var indexOfActiveCall = ownActiveCalls.findIndex(function (activeCall) {
      return activeCall.get('key') === activeCallKey;
    });
    if (indexOfActiveCall === -1) {
      // The event was dispatched for a call other than our calls. We don't care about these.
      // A call can only be answered by one device, so this is enough to decide the logged-in
      // user answered a call "somwhere".
      return;
    }
    var localCallIds = getLocalCallIds(getState());
    var activeCallId = ownActiveCalls.getIn([indexOfActiveCall, 'callId']);
    if (localCallIds.includes(activeCallId)) {
      setMainRegistration();
    }
    var ctiSettings = getCtiSetting(getState());
    var focusedActiveCall = getFocusedActiveCall(getState());
    var locutusSessionId = focusedActiveCall.get('locutusSessionId');
    var _ctiCallInfoFromActiv = ctiCallInfoFromActiveCall(focusedActiveCall, getState()),
      localNumber = _ctiCallInfoFromActiv.localNumber,
      number = _ctiCallInfoFromActiv.remoteNumber,
      direction = _ctiCallInfoFromActiv.direction,
      queueName = _ctiCallInfoFromActiv.queueName,
      startTime = _ctiCallInfoFromActiv.startTime;
    var data = {
      openOnAnswer: (_ctiSettings$openOnAn = ctiSettings.openOnAnswer) === null || _ctiSettings$openOnAn === void 0 ? void 0 : _ctiSettings$openOnAn.value,
      myNumber: localNumber,
      callInfo: {
        direction: capitalizeFirstLetter(direction),
        number: number,
        locutusSessionId: locutusSessionId,
        queueName: queueName,
        startTime: startTime
      }
    };
    dispatch(send(OUTGOING_EVENTS.CALL_ANSWERED, data));
  };
};
export var getContactDecorations = function getContactDecorations(calls) {
  return function (dispatch) {
    if (!(calls && calls.records)) {
      return;
    }
    var numbersSet = new Set(calls.records.map(function (call) {
      return call.number.number;
    }));
    dispatch(send(OUTGOING_EVENTS.GET_CONTACT_DECORATIONS, {
      numbers: Array.from(numbersSet)
    }));
  };
};
export var getDecoratedCall = function getDecoratedCall(numberE164, direction, bagVariables, queueName, startTime) {
  return function (dispatch) {
    dispatch(send(OUTGOING_EVENTS.GET_CONTACT_DECORATIONS, {
      numbers: [numberE164],
      direction: direction,
      bagVariables: bagVariables,
      queueName: queueName,
      startTime: startTime
    }));
  };
};
export var sendProxyResponse = function sendProxyResponse(response, proxyRequestId) {
  return function (dispatch) {
    dispatch(send(OUTGOING_EVENTS.PROXY_REQUEST_RESPONSE, {
      response: response,
      proxyRequestId: proxyRequestId
    }));
  };
};
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : null;
};
export var handleCtiClick = function handleCtiClick(routeInfo, myNumber, callInfo, metaData) {
  return function (dispatch, getState) {
    if (!routeInfo) {
      return;
    }
    var _getState4 = getState(),
      app = _getState4.app,
      integration = _getState4.integration;
    var activeCall = integration.get('activeCall');
    var metadata = callInfo && callInfo.number ? getIntegrationContactMetaDataByNumber(getState(), callInfo.number) : {};
    var locutusSessionId;
    var focusedActiveCall = getFocusedActiveCall(getState());
    if (focusedActiveCall) {
      //event incoming outgoing call
      locutusSessionId = focusedActiveCall.get('locutusSessionId');
    } else if (callInfo && callInfo.callRecordKey) {
      //event from history
      locutusSessionId = callInfo.callRecordKey.replace('call-', '');
    }
    var ctiSettings = getCtiSetting(getState());
    if (callInfo === undefined) {
      var data = {
        routeInfo: routeInfo
      };
      data.ctiSettings = ctiSettings;
      if (activeCall) {
        var number = getOtherNumber(activeCall);
        var direction = getFormattedDirection(activeCall);
        var _myNumber = getMyNumber(activeCall);
        data.callInfo = {
          direction: capitalizeFirstLetter(direction),
          number: number
        };
        data.myNumber = _myNumber;
      }
      if (metaData) {
        data.metadata = metaData;
      }
      data.hasCallLoggingApp = app.getIn(['extension', 'hasZendeskCallLoggingApp']);
      dispatch(send(OUTGOING_EVENTS.PARENT_ROUTE_REQUEST, data));
    } else {
      var _data = _objectSpread(_objectSpread(_objectSpread({}, {
        callInfo: _objectSpread(_objectSpread({}, callInfo), {}, {
          direction: capitalizeFirstLetter(callInfo.direction),
          locutusSessionId: locutusSessionId
        })
      }), {}, {
        routeInfo: routeInfo,
        myNumber: myNumber
      }, metadata && {
        metadata: metadata
      }), {}, {
        ctiSettings: ctiSettings,
        hasCallLoggingApp: app.getIn(['extension', 'hasZendeskCallLoggingApp'])
      });
      dispatch(send(OUTGOING_EVENTS.PARENT_ROUTE_REQUEST, _data));
    }
  };
};
export var setSelectedCtiContact = function setSelectedCtiContact(contact) {
  return {
    type: Actions.CTI_SET_SELECTED_CONTACT,
    contact: contact
  };
};
var proxyRequestCallback = function proxyRequestCallback(dispatch, proxyRequestId) {
  return {
    onResult: function onResult(result) {
      var response = {
        ok: true,
        status: result.statusCode,
        proxyRequestId: proxyRequestId,
        body: JSON.parse(result.data)
      };
      dispatch(sendProxyResponse(response, proxyRequestId));
    },
    onClientError: function onClientError(error) {
      var response = {
        ok: false,
        status: error.status,
        statusText: error.statusText,
        response: error.response,
        responseText: error.responseText,
        proxyRequestId: proxyRequestId
      };
      dispatch(sendProxyResponse(response, proxyRequestId));
    },
    onError: function onError(error) {
      var response = {
        ok: false,
        status: error.status,
        statusText: error.statusText,
        response: error.response,
        responseText: error.responseText,
        proxyRequestId: proxyRequestId
      };
      dispatch(sendProxyResponse(response, proxyRequestId));
    }
  };
};
var performProxyRequest = function performProxyRequest(callback, urlEnding, options) {
  var conf = _objectSpread({
    path: urlEnding,
    method: 'GET'
  }, options !== undefined && options);
  HomeClient.exec(callback, conf);
};
var handleEventFromHostSystem = function handleEventFromHostSystem(dispatch, getState) {
  return function (event) {
    addCtiLogEntry('Got message from host system.', event.data);
    var typeAsString = event.data.type;
    var actionType = getActionFromIncomingEvent(typeAsString);
    if (typeAsString === INCOMING_EVENTS.PROXY_REQUEST) {
      var _event$data = event.data,
        url = _event$data.url,
        options = _event$data.options,
        proxyRequestId = _event$data.proxyRequestId;
      var session = getFocusedSession(getState());
      var logId = session && session.data.logId;
      var optionsWithLogId = options || {};
      optionsWithLogId.params = _objectSpread(_objectSpread({}, optionsWithLogId.params), {}, {
        logId: logId
      });
      performProxyRequest(proxyRequestCallback(dispatch, proxyRequestId), url, optionsWithLogId);
    } else if (actionType) {
      addCtiLogEntry('Message matches reducer action. Dispatching', actionType);
      var action = {
        data: event.data,
        targetOrigin: event.origin,
        type: actionType
      };
      dispatch(action);
    } else if (typeAsString === INCOMING_EVENTS.DIAL_NUMBER) {
      addCtiLogEntry('Message matches dial. Dispatching show call dialog.');
      dispatch(showCallDialog(event.data.phoneNumber));
    } else {
      addCtiLogEntry('Message did not match any usecase. No action taken.');
    }
  };
};
export var setHomeClientHeaderForSameSiteCookie = function setHomeClientHeaderForSameSiteCookie() {
  HomeClient.installSameSiteHeader();
  addCtiLogEntry('Set Home Client SSNC header.');
};
export var setOverrideTvxClientType = function setOverrideTvxClientType(type) {
  HomeClient.overrideTvxClientType(type);
  addCtiLogEntry("Set HomeClient X-TVXClientType header to ".concat(type, "."));
};

// The app can mount twice per page and each mount attaches. Keep the handler so
// the previous listener can be removed, or host messages get handled once per
// listener.
var hostMessageHandler = null;
export var attachIntegrationHostSystemListener = function attachIntegrationHostSystemListener() {
  return function (dispatch, getState) {
    setHomeClientHeaderForSameSiteCookie();
    setOverrideTvxClientType(CTI_INTEGRATION_CLIENT_TYPE_HEADER);
    fetchFeatureFlagsForUser(dispatch)["catch"](function (error) {
      addCtiLogEntry("fetchFeatureFlagsForUser GET ".concat(error.responseURL, " status:").concat(error.statusText, " response code:").concat(error.status));
    })["finally"](function () {
      if (hostMessageHandler) {
        window.removeEventListener('message', hostMessageHandler, false);
      }
      hostMessageHandler = handleEventFromHostSystem(dispatch, getState);
      window.addEventListener('message', hostMessageHandler, false);
      addCtiLogEntry('Attached host system listener.');
    });
  };
};